import { Group, Text, Button, SimpleGrid, Card, ThemeIcon, Badge, Stack, Divider } from '@mantine/core';
import { IconPlus, IconBuilding, IconMapPin, IconBriefcase, IconPhone } from '@tabler/icons-react';

export default function ConstructionSitesSection({
  constructionSites,
  openNewSite,
  openEditSite,
  handleDeleteSite,
}) {
  return (
    <>
      <Group justify="space-between" mb="md">
        <Text fw={700} size="lg">Şantiyeler ve Projeler</Text>
        <Button leftSection={<IconPlus size={16} />} onClick={openNewSite} color="orange">
          Yeni Şantiye Ekle
        </Button>
      </Group>

      <SimpleGrid cols={{ base: 1, md: 2, lg: 3 }} spacing="lg">
        {constructionSites.map((site) => (
          <Card key={site.id} shadow="sm" padding="lg" radius="md" withBorder>
            <Card.Section withBorder inheritPadding py="xs">
              <Group justify="space-between">
                <Group gap="xs">
                  <ThemeIcon color="orange" variant="light">
                    <IconBuilding size={16} />
                  </ThemeIcon>
                  <Text fw={600}>{site.name}</Text>
                </Group>
                <Badge color={site.is_active ? 'green' : 'gray'}>{site.status}</Badge>
              </Group>
            </Card.Section>

            <Stack mt="md" gap="xs">
              <Group gap="xs">
                <IconMapPin size={16} color="gray" />
                <Text size="sm" c="dimmed">{site.location}</Text>
              </Group>

              {site.project_manager && (
                <Group gap="xs">
                  <IconBriefcase size={16} color="gray" />
                  <Text size="sm">Müdür: {site.project_manager}</Text>
                </Group>
              )}

              {site.contact_phone && (
                <Group gap="xs">
                  <IconPhone size={16} color="gray" />
                  <Text size="sm">{site.contact_phone}</Text>
                </Group>
              )}

              <Divider my="xs" />
              <Text size="xs" c="dimmed">Başlangıç: {site.start_date || '-'}</Text>
              <Text size="xs" c="dimmed">Bitiş: {site.expected_end_date || '-'}</Text>
            </Stack>

            <Group mt="md" justify="flex-end">
              <Button variant="light" color="blue" size="xs" onClick={() => openEditSite(site)}>
                Düzenle
              </Button>
              <Button variant="light" color="red" size="xs" onClick={() => handleDeleteSite(site.id)}>
                Sil
              </Button>
            </Group>
          </Card>
        ))}
      </SimpleGrid>

      {constructionSites.length === 0 && (
        <Text c="dimmed" ta="center" mt="xl">
          Kayıtlı şantiye bulunamadı.
        </Text>
      )}
    </>
  );
}